"use strict";
/**
 * The recorder's game picker (ai/nba/N8-taps/PLAN.md §11.2). Pure: markup in, out. The day is the
 * America/New_York date (the NBA's and ESPN's scoreboard date); tips show in the phone's own
 * time, under the ET date, so the two agree around midnight.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isYmd = void 0;
exports.easternYmd = easternYmd;
exports.shiftYmd = shiftYmd;
exports.renderNbaPicker = renderNbaPicker;
const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
function escapeHtml(value) {
    return value.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);
}
/** YYYYMMDD of the America/New_York day at `ms`. */
function easternYmd(ms) {
    const parts = new Intl.DateTimeFormat("en-US", { timeZone: "America/New_York", year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(new Date(ms));
    const get = (t) => parts.find((p) => p.type === t)?.value ?? "";
    return `${get("year")}${get("month")}${get("day")}`;
}
const utcOf = (ymd) => new Date(Date.UTC(Number(ymd.slice(0, 4)), Number(ymd.slice(4, 6)) - 1, Number(ymd.slice(6))));
/** The calendar date `days` away. */
function shiftYmd(ymd, days) {
    const d = utcOf(ymd);
    d.setUTCDate(d.getUTCDate() + days);
    return d.toISOString().slice(0, 10).replace(/-/g, "");
}
const isYmd = (v) => typeof v === "string" && /^\d{8}$/.test(v) && shiftYmd(v, 0) === v;
exports.isYmd = isYmd;
const ymdLabel = (ymd) => {
    const d = utcOf(ymd);
    return `${DAYS[d.getUTCDay()]} ${MONTHS[d.getUTCMonth()]} ${d.getUTCDate()}`;
};
const localTime = (iso) => new Date(iso).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
/** A game's row offers both pads (N8 §19.5); `data-state` is ESPN's, Pad 2's guess at the opening tip. */
function gameRow(g) {
    const when = g.state === "pre" ? localTime(g.tip) : g.detail;
    return `<div class="nba-pick nba-pick-${escapeHtml(g.state)}" data-game-id="${escapeHtml(g.id)}" data-home="${escapeHtml(g.home)}" data-away="${escapeHtml(g.away)}" data-state="${escapeHtml(g.state)}">
		<span class="nba-pick-time">${escapeHtml(when)}</span>
		<span class="nba-pick-teams">${escapeHtml(`${g.away} @ ${g.home}`)}</span>
		<span class="nba-pick-status">${escapeHtml(g.state === "pre" ? "" : g.state === "in" ? "live" : "final")}</span>
		<span class="nba-pick-pads"><button type="button" class="btn nba-pick-pad" data-pad="1">Pad 1</button><button type="button" class="btn nba-pick-pad" data-pad="2">Pad 2</button></span>
	</div>`;
}
function renderNbaPicker(v) {
    const head = `<div class="nba-pick-head">
		<button type="button" class="btn nba-pick-day" data-date="${shiftYmd(v.date, -1)}" aria-label="Previous day">‹</button>
		<span class="nba-pick-date">${escapeHtml(ymdLabel(v.date))} <small>(ET date)</small></span>
		<button type="button" class="btn nba-pick-day" data-date="${shiftYmd(v.date, 1)}" aria-label="Next day">›</button>
	</div>`;
    if (v.status === "loading")
        return `<div class="nba-picker">${head}<div class="nba-pick-fetched">loading…</div></div>`;
    if (v.status === "unavailable" || !v.schedule) {
        return `<div class="nba-picker">${head}<div class="nba-pick-unavailable">Schedule unavailable. A game link still records: /app/win-prob/nba/&lt;gameId&gt;/tap?home=…&amp;away=…</div></div>`;
    }
    const s = v.schedule;
    const fetched = `fetched ${escapeHtml(localTime(s.fetchedAt))}${s.stale ? " · stale (ESPN not answering)" : ""}`;
    const body = s.games.length
        ? `<div class="nba-pick-list">${s.games.map(gameRow).join("")}</div>`
        : `<div class="nba-pick-empty">No NBA games on this date.</div>`;
    return `<div class="nba-picker">${head}<div class="nba-pick-fetched">${fetched}</div>${body}</div>`;
}
